import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Coins } from "lucide-react";

const SOURCE_LABEL = { offer: "Vendite marketplace", quote: "Preventivi", booking: "Prenotazioni", gold: "Abbonamenti Oro", external_sale: "Vendite esterne" };

export default function CommissionsCard() {
  const [rev, setRev] = useState(null);
  useEffect(() => {
    api.get("/revenue").then(({ data }) => setRev(data)).catch(() => setRev({ total: 0, by_source: {}, recent: [] }));
  }, []);

  return (
    <div data-testid="commissions-card" className="border border-neutral-200 rounded-2xl p-4">
      <div className="flex items-center gap-2 mb-1">
        <Coins size={18} />
        <h2 className="font-display font-bold">Commissioni ENBISSY ricevute</h2>
      </div>
      <p className="text-xs text-neutral-500 mb-3">Solo denaro reale: il 10% trattenuto sui pagamenti Stripe andati a buon fine.</p>
      <div className="rounded-2xl bg-black text-white p-4 mb-3">
        <p className="text-xs opacity-70">Totale commissioni</p>
        <p data-testid="commissions-total" className="font-display text-3xl font-extrabold">€{(rev?.total ?? 0).toFixed(2)}</p>
      </div>
      {rev && rev.declared_total > 0 && (
        <p data-testid="commissions-declared" className="text-xs text-amber-800 bg-amber-50 border border-amber-100 rounded-xl p-3 mb-3">
          Commissioni dichiarate su vendite esterne (non incassate su Stripe): €{rev.declared_total.toFixed(2)}
        </p>
      )}
      {rev && Object.keys(rev.by_source).length > 0 && (
        <div className="grid grid-cols-2 gap-2 mb-3">
          {Object.entries(rev.by_source).map(([k, v]) => (
            <div key={k} data-testid={`commissions-source-${k}`} className="rounded-xl bg-neutral-50 p-3">
              <p className="text-xs text-neutral-500">{SOURCE_LABEL[k] || k}</p>
              <p className="font-display font-extrabold">€{v.toFixed(2)}</p>
            </div>
          ))}
        </div>
      )}
      <div className="space-y-1">
        {(rev?.recent || []).slice(0, 10).map((r) => (
          <div key={r.id} data-testid={`commission-${r.id}`} className="flex items-center justify-between text-sm border-b border-neutral-100 py-2 last:border-0">
            <div><p className="font-medium">{r.label}</p><p className="text-xs text-neutral-400">{new Date(r.created_at).toLocaleDateString("it-IT")}</p></div>
            <p className="font-display font-bold text-green-700">+€{r.amount.toFixed(2)}</p>
          </div>
        ))}
        {rev && rev.recent.length === 0 && <p data-testid="commissions-empty" className="text-xs text-neutral-400">Nessuna commissione ancora: arriverà con il primo pagamento.</p>}
      </div>
    </div>
  );
}
